import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";

// 安装路由
Vue.use(VueRouter);

// 解决vue报错vue-router.esm.js?8c4f:2007 Uncaught (in promise) NavigationDuplicated {_name: “NavigationDuplicated”, name: “NavigationDuplicated”}
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
    return routerPush.call(this, location).catch(error => error);
};

const routerOption = {
    mode: "history",
    routes
};
const router = new VueRouter(routerOption);

router.beforeEach((to, from, next) => {
    Vue.prototype.$Loading.start();
    const { authtoken, systemTitle, companyId } = router.app.$store.getters;
    window.document.title = `${to.meta.title || ""} - ${systemTitle}`;

    // 登录页
    if (to.meta.norpermission) {
        next();
    }
    // 未登录状态
    else if (!authtoken) {
        // 若为直接进入，跳转欢迎页，若刷新页面发现登录失效，跳转login
        next({ name: "introduction" });
    }
    else if (to.name === "home") {
        next({
            name: "myApp",
            params: { companyId }
        });
    }
    else {
        next();
    }
});

router.afterEach((to) => {
    Vue.prototype.$Loading.finish();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js